export const SystemUserRole = { User: "0", SuperUser: "1", Admin: "2", Invisible: "3" };
